const blockquote = {
  default: {
    fontSize: 4,
    lineHeight: 'body',
    color: 'primary',
    fontWeight: 'strong',
    margin: 6,
    padding: '0 0 0 20px'
  }
};

export type BlockquoteVariantsType = 'default';
export const blockquoteVariants = Object.keys(blockquote) as BlockquoteVariantsType[];

export default blockquote;
